var render = function render(){var _vm=this,_c=_vm._self._c;return _c('manage-password',{attrs:{"title":"User Profile"}})
}
var staticRenderFns = []

export { render, staticRenderFns }